import { Table as TanStackTable } from '@tanstack/react-table';
import { Button } from '@lmig/lmds-react-button';
import { Tag } from '@lmig/lmds-react-tag';
import './FilterTagsFromTable.scss';

interface FilterTagsFromTableProps {
  tableInstance: TanStackTable<any>;
}

export function FilterTagsFromTable({ tableInstance }: FilterTagsFromTableProps) {
  const activeFilters = tableInstance
    .getAllColumns()
    .filter((column) => column.getIsFiltered())
    .map((column) => ({
      id: column.id,
      header: column.columnDef.header as string,
      value: column.getFilterValue(),
    }));

  if (activeFilters.length === 0) {
    return null;
  }

  return (
    <div className="filter-tags-container">
      <span className="filter-tags-label">Active filters:</span>
      {activeFilters.map((filter) => {
        const displayValue = Array.isArray(filter.value)
          ? filter.value.join(', ')
          : String(filter.value);

        return (
          <Tag
            key={filter.id}
            onClear={() => {
              const column = tableInstance.getColumn(filter.id);
              column?.setFilterValue(undefined);
            }}
          >
            {filter.header}: {displayValue}
          </Tag>
        );
      })}
    </div>
  );
}
